import request from '@/util/request';

export const getList = () => request.get('/api/ding/callbacktag/list', {});

export const register = (tags) => {
  return request({
    url: '/api/ding/callbacktag/register',
    method: 'get',
    params: {
      tags,
    },
  });
};

export const registerUpdate = (tags) => {
  return request({
    url: '/api/ding/callbacktag/register/update',
    method: 'get',
    params: {
      tags,
    },
  });
};

export const registerDelete = () =>
  request.request({ url: '/api/ding/callbacktag/register/delete', method: 'delete', params: {} });

export const registerDetails = () =>
  request.request({ url: '/api/ding/callbacktag/register/details', method: 'get', params: {} });

export const add = (row) => {
  return request({
    url: '/api/ding/callbacktag/add',
    method: 'post',
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: '/api/ding/callbacktag/update',
    method: 'post',
    data: row,
  });
};

export const del = (id) => {
  return request({
    url: '/api/ding/callbacktag/delete',
    method: 'delete',
    params: {
      id,
    },
  });
};
